import { useMemo } from "react";
import { useEffect, useState } from "react";
import { usePermission } from "../use-auth";

export const useModifyOptions = (status) => {
  const { createPermission, editPermission, cancelPermission } =
    usePermission();

  const defaultModifyOptions = useMemo(
    () => [
      {
        value: "ยกเลิก",
        disabled: !cancelPermission,
      },
      {
        value: "แก้ไข",
        disabled: !editPermission,
      },
      {
        value: "คัดลอก",
        disabled: !createPermission,
      },
    ],
    [cancelPermission, createPermission, editPermission]
  );

  const [selectModifyOptions, setSelectedModifyOptions] =
    useState(defaultModifyOptions);

  useEffect(() => {
    switch (status) {
      case "draft":
      case "not_approve_audit":
      case "not_approve_queue":
      case "not_approve_review":
        setSelectedModifyOptions([
          defaultModifyOptions[0],
          defaultModifyOptions[2],
        ]);
        break;
      case "cancelled":
        setSelectedModifyOptions([defaultModifyOptions[2]]);
        break;
      case "finished":
        setSelectedModifyOptions([
          defaultModifyOptions[1],
          defaultModifyOptions[2],
        ]);
        break;
      default:
        setSelectedModifyOptions(defaultModifyOptions);
    }
  }, [defaultModifyOptions, status]);

  return selectModifyOptions;
};
